import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';

export interface IWorkbenchLayout {
  layout: any,
}

@Module({ dynamic: true, store, name: 'workbenchlayout' })
class WorkbenchLayout extends VuexModule {
    public layout:any = sessionStorage.getItem('store') && JSON.parse(sessionStorage.getItem('store') as string).workbenchlayout ? JSON.parse(sessionStorage.getItem('store') as string).workbenchlayout.layout : []
    getModule: any;
    get getLayout() {
      return this.layout;
    }
    @Mutation
    private SET_LAYOUT(layout: any) {
      this.layout = layout;
    }
    @Action
    public async setLayout(layout: any) {
      this.SET_LAYOUT(layout);
    }
}
export const WorkbenchLayoutModule = getModule(WorkbenchLayout);
